import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CompanyDomain, CompanyDomainCreate, CompanyDomainUpdate } from '@shared/definitions';
import { Observable } from 'rxjs';

/* PAUL-3950: a company's custom web addresses. Reads are open to the company's users (the POS form fills its
   dropdown from the list); every write is Pauly-admin only and answers 403 otherwise. */
@Injectable({
  providedIn: 'root',
})
export class CompanyDomainsApiService {
  readonly baseUrl = '/api/v1.0/companies/domains';

  constructor(private http: HttpClient) {}

  // The records cost two Azure reads per row, so only the Integrations section asks for them.
  getCompanyDomains = (companyId: string, includeRecords = false) =>
    this.http.get<CompanyDomain[]>(`${this.baseUrl}/${companyId}`, {
      params: includeRecords ? { include_records: true } : {},
    });

  addCompanyDomain = (body: CompanyDomainCreate) => this.http.post<CompanyDomain>(this.baseUrl, body);

  editCompanyDomain = (body: CompanyDomainUpdate) => this.http.put<CompanyDomain>(this.baseUrl, body);

  // Refused with company_domain_in_use while a point of sale still uses the address.
  removeCompanyDomain = (id: string) => this.http.delete(`${this.baseUrl}/${id}`);

  validateCompanyDomain = (id: string) => this.http.post<CompanyDomain>(`${this.baseUrl}/validate/${id}`, {});

  // Full response: the filename to save under comes from the Content-Disposition header, since the export
  // is an xlsx workbook.
  exportCompanyDomains = (companyId: string, domainId?: string): Observable<HttpResponse<Blob>> =>
    this.http.get(`${this.baseUrl}/${companyId}/export`, {
      responseType: 'blob',
      observe: 'response',
      params: domainId ? { domain_id: domainId } : {},
    });
}
